import React, { useEffect, useState, useRef } from "react";
import Dialog, { DialogHeader } from "../../bootstrap/Dialog.jsx";
import PrefillSourceAgGrouped from "./PrefillSourceAgGrouped.jsx";
import LoadingIndicator from "../../common/loading_indicator.jsx";
import Tooltip from '../../common/Tooltip.jsx'
import MuiTooltip from '@mui/material/Tooltip';

import { project_report_get_prefill_source_answers_for_links_path } from '~/routes';

const TOOLTIP_STYLES = {
  tooltip: {
    sx: {
        background: '#FAFAFA',
        color: '#666',
        fontSize: '13px',
        maxWidth: 500,
    }
  },
  popper: {
    sx: {
        pointerEvents: 'auto'
    }
  },
  tooltipArrow: {
    sx: {
        background: '#FAFAFA'
    }
  }
};

const Instructions = (
    <div>
        <p>You can use library of existing form submissions to populate the key information into the current form.</p><br />
        <h5><b>Submission type</b></h5><br />
        <p>Select relevant submission / report type that you wish to use as a source of data to be populated into the current form.</p><br />
        <h5><b>Submission entry</b></h5><br />
        <p>Select a single entry of the selected submission type which shall be used as source of data to be populated into the current form.</p><br />
        <h5><b>Apply library</b></h5><br />
        <p>You can choose to apply currently selected library to automatically populate all matching form fields into the current form.</p><br />
        <h5><b>Empty fields only</b></h5><br />
        <p>Applying the library to empty fields only will populate matching answers from the source form only to those form fields which do not contain any answers saved on the current form.</p>
    </div>
)

const PrefillSourceSelectionDialog = ({prefillContextFormLinks, setPrefillPreviewStatus, setPrefillAnswersFromMulti, setMultiSourceSelectionStatus, existingAnswersKeys}) => {
    const [loading, setLoading] = useState(true);
    const [prefill_answers, setAnswers] = useState([]);
    const [open, setOpen] = React.useState(false);

    const handleTooltipClose = () => {
      setOpen(false);
    };
  
    const handleTooltipToggle = () => {
      setOpen(o => !o);
    };
    const agRef = useRef();
    useEffect(() => {
        if (prefillContextFormLinks) {
            jQuery.getJSON(
                project_report_get_prefill_source_answers_for_links_path({
                    links: prefillContextFormLinks,
                }),
                (data) => {
                    setAnswers(data)
                    setLoading(false);
                }
            );
        } else {
            setLoading(false);
        }
    }, [prefillContextFormLinks]);

    getCurrentSelectedAnswers = (all) => {
        const selectedData = agRef.current.getSelectedRows();
        const mergedAnswers = selectedData.reduce((acc, item) => {
            if (!acc[item.project_id]) {
                acc[item.project_id] = {};
            }
            data = all ? item.form_data : 
            Object.entries(item.form_data).filter(([key]) => !existingAnswersKeys.includes(key))
            .reduce((acc, [key, value]) => {
                acc[key] = value;
                return acc;
            }, {});
    
            acc[item.project_id] = { ...acc[item.project_id], ...data };
            return acc;
        }, {});
        return mergedAnswers
    }

    prefillBlank = () => {
        setPrefillPreviewStatus(false)
        setPrefillAnswersFromMulti(getCurrentSelectedAnswers(false))
        setMultiSourceSelectionStatus(false)
    }
    prefillAll = () => {
        const userConfirmed = confirm(I18n.t('prefill_from_multi_modal_prefill_all_confirm'));
        if (userConfirmed) {
            setPrefillPreviewStatus(false)
            setPrefillAnswersFromMulti(getCurrentSelectedAnswers(true))
            setMultiSourceSelectionStatus(false)
        }
    }
    onClose = () => {
        setPrefillPreviewStatus(false)
        setPrefillAnswersFromMulti({})
        setMultiSourceSelectionStatus(false)
    }
    prefillPreview = () => {
        setPrefillPreviewStatus(true)
        setPrefillAnswersFromMulti(getCurrentSelectedAnswers(true))
        setMultiSourceSelectionStatus(false)
    }

    const footer = (
        <PrefillDialogFooter
          onClose={onClose}
          prefillAll={prefillAll}
          prefillBlank={prefillBlank}
          prefillPreview={prefillPreview}
          prefillAllText={I18n.t('prefill_from_multi_modal_prefill_all')}
          prefillBlankText={I18n.t('prefill_from_multi_modal_prefill_blank')}
        />
      );
    const header = <DialogHeader onClose={onClose} title={I18n.t('prefill_from_multi_modal_title')} />;
    return <Dialog footer={footer} header={header}>
        <p className="descriptions">{I18n.t('prefill_from_multi_modal_description')}</p>
        {
            loading ? (
                <LoadingIndicator />
            ) : prefill_answers.length > 0 ? (
                <PrefillSourceAgGrouped ref={agRef} sourceData = {prefill_answers} setPrefillAnswersFromMulti = {setPrefillAnswersFromMulti} />)
                : null
        }
        <MuiTooltip
            onClose={handleTooltipClose}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            slotProps={TOOLTIP_STYLES}
            title={Instructions}
            placement='bottom'
            >
            <a onClick={handleTooltipToggle}>{I18n.t('code_editor_help')}</a>
        </MuiTooltip>
    </Dialog>;
};

const PrefillDialogFooter = ({onClose, prefillPreview, prefillAll, prefillAllText, prefillBlank, prefillBlankText}) => (
    <div className="modal-footer">
        <button className="btn btn-default pull-left" onClick={onClose}>{I18n.t('close')}</button>
        <button className="btn btn-default pull-left" onClick={prefillPreview}>{I18n.t('preview')}</button>
        <button className="btn btn-primary mr-1" onClick={prefillAll}>{prefillAllText}</button>
        <Tooltip title={I18n.t("prefill_from_multi_modal_prefill_blank_description")}>
            <button className="btn btn-default" onClick={prefillBlank}>{prefillBlankText}</button>
        </Tooltip>
    </div>
)

export default PrefillSourceSelectionDialog;